var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinner = function SvgSpinner(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    viewBox: "0 0 200 200",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spinner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 100a100 100 0 1 1-19.098-58.779 17 17 0 1 1-27.507 19.985A66 66 0 1 0 166 100z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spinner_svg__b",
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "spinner_svg__c",
    d: "M250 100a150 150 0 0 1-3.28 31.19L100 100z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#spinner_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#spinner_svg__b)",
    transform: "rotate(-6 100 100)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.03,
    transform: "rotate(12 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.07,
    transform: "rotate(24 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.1,
    transform: "rotate(36 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.14,
    transform: "rotate(48 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.17,
    transform: "rotate(60 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.2,
    transform: "rotate(72 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.24,
    transform: "rotate(84 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.28,
    transform: "rotate(96 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.31,
    transform: "rotate(108 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.34,
    transform: "rotate(120 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.38,
    transform: "rotate(132 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.41,
    transform: "rotate(144 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.45,
    transform: "rotate(156 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.48,
    transform: "rotate(168 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.52,
    transform: "rotate(180 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.55,
    transform: "rotate(192 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.59,
    transform: "rotate(204 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.62,
    transform: "rotate(216 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.66,
    transform: "rotate(228 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.69,
    transform: "rotate(240 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.7,
    transform: "rotate(252 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.72,
    transform: "rotate(264 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.76,
    transform: "rotate(276 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.79,
    transform: "rotate(288 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.83,
    transform: "rotate(300 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.86,
    transform: "rotate(312 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.93,
    transform: "rotate(324 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    fillOpacity: 0.97,
    transform: "rotate(336 100 100)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#spinner_svg__c",
    transform: "rotate(348 100 100)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";